// Interceptor para manejar automáticamente errores 401
class AuthInterceptor {
  constructor() {
    this.onUnauthorized = null;
  }

  setOnUnauthorized(callback) {
    this.onUnauthorized = callback;
  }

  handleResponse(response) {
    if (response.status === 401) {
      // Limpiar tokens
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      
      // Ejecutar callback si está definido
      if (this.onUnauthorized) {
        this.onUnauthorized();
      } else {
        // Redirigir al login por defecto
        window.location.href = '/login';
      }
      
      throw new Error('Unauthorized - Token expired or invalid');
    }
    
    return response;
  }
}

// Instancia global del interceptor
export const authInterceptor = new AuthInterceptor();

// Función mejorada para hacer peticiones con interceptor
export const authenticatedRequest = async (url, options = {}) => {
  const token = localStorage.getItem('accessToken');
  
  // Separar headers de las demás opciones para evitar sobrescribirlas
  const { headers: customHeaders, ...restOptions } = options;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...customHeaders, // Fusionar headers personalizados sin perder el token
    },
    ...restOptions, // Resto de opciones (method, body, etc.)
  };

  try {
    const response = await fetch(url, defaultOptions);
    
    // Usar el interceptor para manejar 401
    authInterceptor.handleResponse(response);
    
    // Verificar si la respuesta es exitosa (códigos 200-299)
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    // Manejar códigos de éxito específicos (200, 201, etc.)
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      // Para 204 No Content, no hay body que parsear
      if (response.status === 204) {
        return { success: true };
      }
      return await response.json();
    }
    
    return await response.json();
  } catch (error) {
    console.error('Authenticated request failed:', error);
    throw error;
  }
};





